<div class="tableInfo" *ngIf="res">
  <h2 class="titleTable">General</h2>
  <mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <!-- Position Column -->
    <div *ngFor="let labels of res.labelsUnitTable">
      <ng-container [matColumnDef]="labels">
        <mat-header-cell *matHeaderCellDef>{{ labels }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element[labels] }}
        </mat-cell>
      </ng-container>
    </div>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
<div class="graphics">
  <h1 class="title">Total de Casos Analytiko</h1>

  <div class="divChart" id="contentGeneralReportResume">
    <canvas id="GeneralReportResume" width="30"></canvas>
  </div>
</div>
<div class="graphics">
  <h1 class="title">Total de Casos Analytiko Gerencia / Estátus</h1>
  <div class="divChart" id="contentGeneralReportResumeStatus">
    <canvas id="GeneralReportResumeStatus" width="30"></canvas>
  </div>
</div>
